/**
 * Detects backend errors that mean the client's view of the current layer is
 * out of date (a concurrent amendment/edit changed the current layer, or the
 * targeted layer is no longer current). When this happens the UI should refetch
 * the layer list so the user sees the fresh current layer rather than acting on
 * stale state.
 *
 * Matches the stable backend messages:
 * - amendment: "Expected current OTC contract layer is stale"
 * - current-layer update: "OTC contract layer is not current"
 */
export function isStaleLayerError(message?: string): boolean {
  if (!message) return false;
  const normalized = message.toLowerCase();
  return (
    normalized.includes("expected current otc contract layer is stale") ||
    normalized.includes("otc contract layer is not current")
  );
}
